import 'arrive';

document.arrive('#component-pop-up-checkout', { existing: true }, function () {
  const popup = document.getElementById('component-pop-up-checkout');
  if (!popup) return;

  const closeBtn = popup.querySelector('.custom-popup__close');
  const cookieName = popup.dataset.cookieName || 'hb_checkout_phone_popup_closed';
  const cookieDurationDays = 1;

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
  }

  function getCookie(name) {
    return document.cookie.split('; ').find((row) => row.startsWith(name + '='))?.split('=')[1];
  }

  function showPopup() {
    if (getCookie(cookieName)) return;
    popup.classList.add('is-visible');
  }

  function hidePopup() {
    popup.classList.remove('is-visible');
    setCookie(cookieName, 'true', cookieDurationDays);
  }

  closeBtn?.addEventListener('click', hidePopup);

  // Trigger: compare non a tempo come gli altri pop-up, ma appena l'utente inizia a
  // compilare uno dei due campi telefono del checkout (billing_phone o phone_shipping).
  // document.arrive perché questi campi possono comparire/ricomparire dopo un refresh
  // AJAX del checkout (es. woocommerce update_checkout), non solo al primo caricamento.
  document.arrive('#billing_phone, #phone_shipping', { existing: true }, function (field) {
    field.addEventListener('focus', showPopup, { once: true });
  });
});
